import Swiper, { EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { domContentLoadEvent } from '../common/domContentLoadEvent';

document.addEventListener('scroll', function () {
    const position = document.body.getBoundingClientRect().top;

    if (position < 0) {
        document.querySelector('header').classList.add('scrolled');
        document.querySelector('main').classList.add('scrolled');
    } else {
        document.querySelector('header').classList.remove('scrolled');
        document.querySelector('main').classList.remove('scrolled');
    }
});

function setupSliderMenu() {
    const sliderMenu = new Swiper(document.querySelector('.swiperMenu'), {
        modules: [EffectFade],
        slidesPerView: 1,
        loop: false,
        effect: 'fade',
        speed: 300,
    });
    document.querySelectorAll('.main-menu li a').forEach(function (element) {
        element.addEventListener('mouseover', function () {
            const dataSlide = element.getAttribute('data-slide');
            sliderMenu.slideTo(Number(dataSlide), 1000, false);
        });
    });
}

function setMenu(container) {
    const menuTriggers = document.querySelectorAll(container + ' .menu-btn');

    const body = document.querySelector('body');

    menuTriggers.forEach(function (menuTrigger) {
        menuTrigger.addEventListener('click', function () {
            body.classList.toggle('is-menu-open');
        });
    });
}

function setupSearchForm(container) {
    const searchForm = document.querySelector(container + ' .search-form');
    const searchFormInput = document.querySelector(container + ' .search-form input');
    const containerSearch = document.querySelector(container);

    searchForm.addEventListener('click', function () {
        containerSearch.classList.toggle('search-active');

        if (!containerSearch.classList.contains('search-active')) {
            searchFormInput.placeholder = '';
            searchFormInput.blur();
        } else {
            searchFormInput.placeholder = searchFormInput.getAttribute('data-placeholder');
            searchFormInput.focus();
        }
    });
}

function initialize() {
    setupSliderMenu();

    const isMobile = window.outerWidth < 1024 ? true : false; //Apesar de funcionar, é ruim fazer nesse formato

    if (isMobile) {
        setupSearchForm('.menu-mobile-actions');
    } else {
        setupSearchForm('.header-right');
    }

    setMenu('header');
}

// SCROLL TOP
function scrollToTop() {
    const btnArrowUp = document.querySelector('.btn-footer-arrow-up');
    if (btnArrowUp) {
        btnArrowUp.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }
}
domContentLoadEvent(initialize);
domContentLoadEvent(scrollToTop);
